// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container{
    width: 100%;
    padding: 0px;
    box-sizing: border-box;
    color: #333;
    z-index: 10;
}

.product-info-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.info-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: space-between;
}

.image-wrapper {
    width: 80%;
    margin-left: 20px;
}

.product-image {
    max-width: 100%;
    height: auto;
    display: block;
}

.u-value-section {
    width: 100%; /* Text section takes up the remaining 2/3 of the width */
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: center;
    align-items: center;
}

.u-value-label {
    font-size: 16px;
}

.u-value-display {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 5px;
    outline: 1px solid black;
    border-radius: 6px;
    padding: 10px 20px;
}

.u-value-container{
    display: flex;
    align-items: baseline;
    gap: 10px;
    justify-content: center;
}

.u-value-unit {
    font-size: 16px;
}


.no-image {
    font-size: 1rem;
    color: #888;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 250px;
}`, "",{"version":3,"sources":["webpack://./src/MobileProductDisplay.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW,EAAE,yDAAyD;IACtE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB","sourcesContent":[".footer-container{\n    width: 100%;\n    padding: 0px;\n    box-sizing: border-box;\n    color: #333;\n    z-index: 10;\n}\n\n.product-info-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n.info-wrapper {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.image-wrapper {\n    width: 80%;\n    margin-left: 20px;\n}\n\n.product-image {\n    max-width: 100%;\n    height: auto;\n    display: block;\n}\n\n.u-value-section {\n    width: 100%; /* Text section takes up the remaining 2/3 of the width */\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    justify-content: center;\n    align-items: center;\n}\n\n.u-value-label {\n    font-size: 16px;\n}\n\n.u-value-display {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 5px;\n    outline: 1px solid black;\n    border-radius: 6px;\n    padding: 10px 20px;\n}\n\n.u-value-container{\n    display: flex;\n    align-items: baseline;\n    gap: 10px;\n    justify-content: center;\n}\n\n.u-value-unit {\n    font-size: 16px;\n}\n\n\n.no-image {\n    font-size: 1rem;\n    color: #888;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 250px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
